// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      variants: [
        {
          props: {
            variant: 'black'
          },
          style: {
            backgroundColor: '#202020',
            border: 'none',
            color: '#FFFF'
          }
        },
        {
          props: {
            variant: 'table-gray'
          }
        }
      ],
      styleOverrides: {
        root: {
          '&:hover': {
            boxShadow: 'none'
          },

          whiteSpace: 'nowrap',
          borderRadius: '4px',
          padding: '14px 20px'
        },
        sizeMedium: {
          height: 40
        },
        sizeLarge: {
          height: 48
        },
        containedInherit: {
          color: theme.palette.grey[800],

          '&:hover': {
            backgroundColor: theme.palette.grey[400]
          }
        },
        containedPrimary: {
          backgroundColor: '#0B1293',

          '&:hover': {
            backgroundColor: '#0A0F65'
          }
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary
        },
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        outlinedPrimary: {
          border: `1px solid #0B1293`,
          color: '#0B1293',

          '&:hover': {
            backgroundColor: '#E5E7FF',
            color: '#0B1293'
          }
        },
        textPrimary: {
          backgroundColor: theme.palette.primary.lighter,
          color: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.darker
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        blackPrimary: {
          backgroundColor: '#202020',
          border: 'none',
          fontWeight: 400,
          fontSize: 12,
          color: '#FFF',

          '&:hover': {
            backgroundColor: '#555'
          }
        },
        'table-gray': {
          backgroundColor: '#E6E6E6',
          border: 'none',
          fontWeight: 400,
          fontSize: 12,
          color: '#000',
          '&:hover': {
            backgroundColor: '#CCC'
          }
        },
        'gray-main-contained': {
          backgroundColor: '#888',
          border: 'none',
          fontWeight: 400,
          fontSize: 12,
          color: '#FFF',
          '&:hover': {
            backgroundColor: '#555'
          }
        },
        'gray-secondary-contained': {
          backgroundColor: '#CCC',
          border: 'none',
          fontWeight: 400,
          fontSize: 12,
          color: '#FFF',
          '&:hover': {
            backgroundColor: '#FFF',
            color: '#AAAAAA'
          }
        }
      }
    }
  };
}
